import { AutorizarPatronFraudeComponent } from '../componentsConstants/beforeFinalize/autorizar-patron-fraude/autorizar-patron-fraude.component';
import { SolicitanteInformadoCorreoComponent } from '../componentsConstants/beforeFinalize/solicitante-informado-correo/solicitante-informado-correo.component';

export const COMPONENTS = [
  {
    name: 'Solicitante informado por correo',
    value: 'SolicitanteInformadoCorreo',
    component: SolicitanteInformadoCorreoComponent,
  },
  {
    name: 'Autorizar/Patron de fraude',
    value: 'AutorizarPatronFraudeComponent',
    component: AutorizarPatronFraudeComponent,
  },
];
